module.exports = __webpack_public_path__ + "static/media/2_en.e3f59660.png";